module.exports = __webpack_public_path__ + "media/src/images/landing/arduino-icon-ab2623c56a8a31d91fe4fb8c47bca83b.png";